import SideMenu from '@/containers/side-menu/SideMenu.vue'
import Dashboard from '@/pages/dashboard/Dashboard'

export default {
  path: '/dashboard',
  name: 'Dashboard',
  components: {
    mainContent: Dashboard,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'dashboard'
    },
    breadcrumb: {
      title: 'Dashboard',
      paths: [
        { title: 'Dashboard' }
      ]
    }
  }
}